import { GetSettings } from "./Settings";
import { UnifyEngine } from "../unify-three/UnifyEngine";
import { Mapping } from "three";

exports.Unify = function(unify) {
  this.unify_id = "ui";

  const menu = document.getElementById("menu");
  const startButton = document.getElementById("startButton");
  const loading = document.getElementById("loading");
  const loadBar = document.getElementById("loadBar");
  const timer = document.getElementById("timer");
  const instructions = document.getElementById("instructions");
  const fps = document.getElementById("frameRate");
  const health = document.getElementById("health");
  const healthbar = document.getElementById("healthBar");
  const found = document.getElementById("objsFound");
  const kills = document.getElementById("kills");
  const endScreen = document.getElementById("endScreen");
  const restartMessage = document.getElementById("restartMessage");
  let numNuggets = GetSettings().numberOfHappyTuneNuggets;

  function zIndex() {
    menu.style.zIndex = 6;
    instructions.style.zIndex = 3;
    timer.style.zIndex = 1;
    health.style.zIndex = 1;
    healthbar.style.zIndex = 1;
  }

  // Load all objects into the scene first before player can start:
  this.loadProgress = loadProgress => {
    loading.style.width = loadProgress + "%";

    if (loadProgress >= 100) {
      barComplete();
    }
  };

  // After loading is complete, loading is removed and start button is revealed:
  function barComplete() {
    loadBar.remove();
    // Change button border color to be purple:
    startButton.style.border = "1.5px solid #9a00fa";
    // Changing button text:
    startButton.innerHTML = "CLICK TO BEGIN";
    startButton.style.color = "#9a00fa";
  }

  // Player clicks start button, reveals instructions:
  function showInstructions() {
    menu.remove();
    unify.engine.start();
  }

  // Player clicks screen to start game:
  function startGame() {
    instructions.remove();
  }

  // Updates player's scores:
  function playerScore() {
    found.innerHTML =
      "Found: " + unify.assets.playerStats.score + " of " + numNuggets;
    kills.innerHTML = "Kills: " + unify.assets.playerStats.kills;
  }

  // Update timer style if less than 10 seconds left:
  function gameTimer() {
    timer.innerHTML =
      "Time Left: " + unify.modules.gameLogic.countdown.toFixed(0);
    if (unify.modules.gameLogic.countdown <= 0) {
      timer.innerHTML = "Time's Up!";
    } else if (unify.modules.gameLogic.countdown <= 10) {
      timer.style.color = "red";
    } else {
      timer.style.color = "white";
    }
  }

  // Update player health bar style if less than 50%:
  function playerHealth() {
    health.style.width = unify.assets.playerStats.health + "%";

    if (unify.assets.playerStats.health <= 50) {
      health.style.backgroundColor = "red";
    } else {
      health.style.backgroundColor = "white";
    }
  }

  // Win or lose
  function winOrLose() {
    if (
      unify.modules.gameLogic.countdown > 0 &&
      unify.assets.playerStats.health > 0 &&
      unify.assets.playerStats.score == numNuggets
    ) {
      createRestartMessage("YOU WIN!");
    } else if (
      unify.assets.playerStats.health <= 0 ||
      unify.modules.gameLogic.countdown <= 0
    ) {
      createRestartMessage("GAME OVER");
    }
  }

  function createRestartMessage(message) {
    restartMessage.innerHTML = message + "<br>" + "<br>";
    endScreen.style.color = "white";
    endScreen.style.opacity = "0.9";
    endScreen.style.background = "black";
    const spacebar = document.createElement("DIV");
    spacebar.style.fontFamily = "'montserrat', sans-serif";
    spacebar.style.fontSize = "20px";
    spacebar.style.fontStyle = "italic";
    spacebar.style.color = "white";
    const text = document.createTextNode("Spacebar to restart game.");
    spacebar.appendChild(text);
    restartMessage.appendChild(spacebar);
  }

  // 0. Update all z-index values
  zIndex();
  // `. Reveal instructions
  startButton.addEventListener("click", showInstructions);
  // 2. Start game:
  unify.modules.gameLogic.addEvent_GameStarted(startGame);
  // 3. Determines if game should end:
  unify.modules.gameLogic.addEvent_GameEnded(winOrLose);

  // Update -----------------------------------------------------------------
  let updateTimer = 60;
  this.update = () => {
    if (unify.modules.gameLogic) {
      updateTimer++;
      gameTimer();
      playerHealth();
      playerScore();

      if (updateTimer >= 60) {
        fps.innerHTML = "FPS: " + unify.getFps();

        updateTimer = 0;
      }
    }
  };
};
